module.exports = __webpack_public_path__ + "static/media/LOGO-NAV.37f09379.png";